import { PrizmLanguagePaginator } from '../../interfaces';

export const PRIZM_ENGLISH_PAGINATOR: PrizmLanguagePaginator = {
  paginator: {
    linesShown: 'Lines shown:',
    fromText: 'out of',
    linesOnPage: 'Lines per page',
    moreButtonLabel: 'Show more',
  },
};
